// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-header {
  color: red;
  font-weight: bold;
  font-size: 3em;
  text-align: center;
}

.info-row-label {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/application/dev/dev.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".info-header {\r\n    color: red;\r\n    font-weight: bold;\r\n    font-size: 3em;\r\n    text-align: center;\r\n}\r\n\r\n.info-row-label {\r\n    text-align: right;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
